/* eslint-disable import/no-anonymous-default-export */
import en from './en'
import zh from './zh'

export default {
    en,
    zh
}